var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "url(#paint0_linear)",
    stroke: "#F39201"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68359 12.8379H8.36914V11.877C9.93359 11.7656 11.1055 10.9219 11.1055 9.46875C11.1055 8.20312 10.2676 7.57031 8.69727 7.20703L8.36914 7.13086V4.8457C9.07812 4.94531 9.55859 5.34375 9.64062 6.03516H11.0059C10.9531 4.6875 9.89844 3.79102 8.36914 3.67383V2.69531H7.68359V3.66797C6.1543 3.7793 5.05859 4.6582 5.05859 6.00586C5.05859 7.23047 5.88477 7.91016 7.38477 8.25586L7.68359 8.32617V10.6992C6.81055 10.6055 6.37695 10.1426 6.27734 9.49805H4.91211C4.95312 10.9219 6.13086 11.7715 7.68359 11.877V12.8379ZM6.47656 5.88867C6.47656 5.37891 6.89258 4.93945 7.68359 4.8457V6.97266C6.81641 6.74414 6.47656 6.39258 6.47656 5.88867ZM9.69336 9.61523C9.69336 10.1953 9.2832 10.623 8.36914 10.7051V8.48438C9.37695 8.73633 9.69336 9.05273 9.69336 9.61523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68359 12.8379H8.36914V11.877C9.93359 11.7656 11.1055 10.9219 11.1055 9.46875C11.1055 8.20312 10.2676 7.57031 8.69727 7.20703L8.36914 7.13086V4.8457C9.07812 4.94531 9.55859 5.34375 9.64062 6.03516H11.0059C10.9531 4.6875 9.89844 3.79102 8.36914 3.67383V2.69531H7.68359V3.66797C6.1543 3.7793 5.05859 4.6582 5.05859 6.00586C5.05859 7.23047 5.88477 7.91016 7.38477 8.25586L7.68359 8.32617V10.6992C6.81055 10.6055 6.37695 10.1426 6.27734 9.49805H4.91211C4.95312 10.9219 6.13086 11.7715 7.68359 11.877V12.8379ZM6.47656 5.88867C6.47656 5.37891 6.89258 4.93945 7.68359 4.8457V6.97266C6.81641 6.74414 6.47656 6.39258 6.47656 5.88867ZM9.69336 9.61523C9.69336 10.1953 9.2832 10.623 8.36914 10.7051V8.48438C9.37695 8.73633 9.69336 9.05273 9.69336 9.61523Z",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 3.65479,
    y: 1.44531,
    width: 8.70066,
    height: 12.6426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar-sign.c5d5008a19e6a6046322e420155e580a.svg";
export { ForwardRef as ReactComponent };